
import { createClient } from '@supabase/supabase-js';

// Use environment variables if available, fall back to build-time values
// In production (Cloudflare Workers), these will be injected at runtime
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://xbpunrccmynzvzcxevhd.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhicHVucmNjbXluenZ6Y3hldmhkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEzMDQxODUsImV4cCI6MjA2Njg4MDE4NX0.BcK4GZ0eDQFSQWh8R1tMLnn_5SwG4eJns7TlPVF0uCY';

// Create Supabase client with default auth persistence
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});
